import useAuth from 'hooks/useAuth';
import React from 'react';
import AutoCreate from './AutomaticCreate';
import ManualCreate from './ManualCreate';

type AppProps = {
  goBack: () => void;
  closeModal?: () => void;
  redirectTo?: 'estimates' | 'estimate-detail';
};

const CreateFromEstimateTemplates: React.FC<AppProps> = ({
  goBack,
  closeModal,
  redirectTo = 'estimate-detail',
}) => {
  const { userInfo } = useAuth();
  if (userInfo?.controls?.can_use_auto_create_estimate_options) {
    return (
      <AutoCreate
        goBack={goBack}
        closeModal={closeModal}
        redirectTo={redirectTo}
      />
    );
  }

  return (
    <ManualCreate
      goBack={goBack}
      closeModal={closeModal}
      redirectTo={redirectTo}
    />
  );
};

export default CreateFromEstimateTemplates;
